if (!window.geroOpeningHoursToggleInit) {
  window.geroOpeningHoursToggleInit = true;

  document.addEventListener("click", (event) => {
    const clickedToggle = event.target.closest(".wt-opening-hours__toggle");
    const clickedContainer = event.target.closest(".wt-opening-hours");

    if (null == clickedToggle && null != clickedContainer) {
      return;
    }

    document.querySelectorAll(".wt-opening-hours").forEach((container) => {
      const toggle = container.querySelector(".wt-opening-hours__toggle");
      const week = container.querySelector(".wt-opening-hours__week");

      if (null == toggle || null == week) {
        return;
      }

      const wasHidden = week.hidden;
      const shouldExpand = toggle === clickedToggle ? wasHidden : false;

      week.hidden = !shouldExpand;
      toggle.setAttribute("aria-expanded", String(shouldExpand));
    });
  });
}
